import { ref, type Ref } from 'vue';
import { useAsyncFetch } from './useAsyncFetch';
import api from '@/services/mediaService';
import { useDelayedLoading } from './useDelayedLoading';

export type Attachment = {
  id: string;
  fileName: string;
  fileSize: number;
  title: string;
  description: string;
  source: string;
  mimeType: string;
};

export function useFileAttachments({ mediaId }: { mediaId: Ref<string> }) {
  const fileAttachments = ref<Attachment[]>([]);
  const { isLoading, startLoading, stopLoading } = useDelayedLoading();

  async function fetchAttachments() {
    try {
      fileAttachments.value = [];
      startLoading();
      const { state: resState } = await useAsyncFetch<Attachment[], Object>(
        api.getAttachments(mediaId.value),
      );
      fileAttachments.value = resState.data;
    } catch (e) {
      console.error(e);
    } finally {
      stopLoading();
    }
  }

  return {
    isLoading,
    fileAttachments,
    fetchAttachments,
  };
}
